import { render, staticRenderFns } from "./Ipcomment.vue?vue&type=template&id=56bc1f7b&scoped=true"
import script from "./Ipcomment.vue?vue&type=script&lang=js"
export * from "./Ipcomment.vue?vue&type=script&lang=js"
import style0 from "./Ipcomment.vue?vue&type=style&index=0&id=56bc1f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc1f7b",
  null
  
)

export default component.exports